import { useQuery } from "@tanstack/react-query"
import { todoQueryKeys } from "@/api/query-keys/todo"
import { getTodoUnreadCount } from "@/api/services/todo"
import { TODO_INBOX_REFETCH_INTERVAL } from "toptaal-shared"

export function useTodoUnreadCountQuery() {
  return useQuery({
    queryKey: todoQueryKeys.unreadCount(),
    queryFn: getTodoUnreadCount,
    select: (data) => data.unreadCount,
    refetchInterval: TODO_INBOX_REFETCH_INTERVAL,
  })
}
